module.exports = __webpack_public_path__ + "img/results_pull_reduce.d52d262f.png";